//sidebar menu item declaration
import React from 'react';
const {

  Widget, // Review//,Post  Dashboard,
} = React.lazy(() => import('../containers'));

const appRoutes = [
  {
    path: process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type',
    module: 'add wall',
    name: 'Add Wall',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="14.998" height="15" viewBox="0 0 14.998 15">
    <path id="Path_20973" data-name="Path 20973" d="M-354.568,46.3a1.106,1.106,0,0,0,1.105-1.1V39.4h5.791a1.105,1.105,0,0,0,1.1-1.1,1.106,1.106,0,0,0-1.1-1.1h-5.791V31.4a1.106,1.106,0,0,0-1.105-1.1,1.106,1.106,0,0,0-1.1,1.1v5.791h-5.792a1.106,1.106,0,0,0-1.1,1.1,1.105,1.105,0,0,0,1.1,1.1h5.792v5.791A1.106,1.106,0,0,0-354.568,46.3Z" transform="translate(362.566 -30.297)" fill="#8392a5"/>
  </svg>
  `,
    type: 'up', component: Widget,
    // submenu: [
    //   { subpath: process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type', subname: 'Add Wall' },
    //   { subpath: process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=list', subname: 'Your Wall' }, 
    // ]
  },
  {
    path: process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=list',
    module: 'your wall',
    name: 'Your Wall',
    icon: `<svg id="Group_19743" data-name="Group 19743" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g id="Group_7870" data-name="Group 7870">
      <path id="Path_19507" data-name="Path 19507" d="M-489.144,204.747a5.942,5.942,0,0,0-5.273-5.273l-.055-.006V204.8h5.333Z" transform="translate(505.139 -199.468)" fill="#8392a5"/>
      <path id="Path_19508" data-name="Path 19508" d="M-486.689,206.778h-6.955v-6.934l-.055-.006c-.264-.026-.534-.04-.8-.04a7.865,7.865,0,0,0-7.858,7.854A7.865,7.865,0,0,0-494.5,215.5a7.864,7.864,0,0,0,7.858-7.852,7.839,7.839,0,0,0-.042-.82Zm-1.766,1.747a6.121,6.121,0,0,1-6.045,5.232,6.113,6.113,0,0,1-6.106-6.106,6.121,6.121,0,0,1,5.23-6.044v6.918Z" transform="translate(502.358 -199.505)" fill="#8392a5"/>
    </g>
  </svg>`,
    type: 'up', component: Widget
  },
  {
    path: process.env.REACT_APP_ROUTE_PREFIX + 'visitor',
    module: 'visitors',
    name: 'Visitors',
    icon: `<svg id="Group_7877" data-name="Group 7877" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path id="Union_17" data-name="Union 17" d="M11.52,13.763A2.24,2.24,0,1,1,13.762,16,2.24,2.24,0,0,1,11.52,13.763ZM2.8,16A2.834,2.834,0,0,1,0,13.2V2.805A2.84,2.84,0,0,1,2.8,0h10.4A2.842,2.842,0,0,1,16,2.805v7.779A4.024,4.024,0,0,0,14.473,9.4V3.044A1.434,1.434,0,0,0,13.037,1.6h-10A1.438,1.438,0,0,0,1.6,3.044v9.919A1.432,1.432,0,0,0,3.037,14.4H9.371A3.913,3.913,0,0,0,10.582,16Zm1.4-7.794L5.4,7,7,8.6,10.6,5l1.193,1.2L7,11Z" fill="#8392a5"/>
  </svg>`,
    type: 'up',
    component: ''
  },

  //{ path: process.env.REACT_APP_ROUTE_PREFIX +'dashboard', module: 'dashboard', name: 'Widget list', icon: 'icon-notification', type: 'up', component: Dashboard },
  // {
  //   path: process.env.REACT_APP_ROUTE_PREFIX + 'wdlist',
  //   module: 'Widget',
  //   name: 'Widget',
  //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18">
  //   <g id="streamline-icon-interface-layout-1_20x20" data-name="streamline-icon-interface-layout-1@20x20" transform="translate(0.286 0.286)">
  //     <path id="Path_20980" data-name="Path 20980" d="M0,0H16V16H0Z" transform="translate(16.714 16.714) rotate(180)" fill="none" stroke="#8392a5" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  //     <path id="Path_20981" data-name="Path 20981" d="M7.857.714v16" transform="translate(-0.989)" fill="none" stroke="#8392a5" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  //     <path id="Path_20982" data-name="Path 20982" d="M7.857,10h8.77" transform="translate(-0.912 -1.286)" fill="none" stroke="#8392a5" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  //   </g>
  // </svg>`,
  //   type: 'up',
  //   component: Widget
  // },

  // { path: process.env.REACT_APP_ROUTE_PREFIX + 'setting', module: 'setting', name: 'Settings', icon: 'icon-setting', type: 'up', component: '' },
  // { path: process.env.REACT_APP_ROUTE_PREFIX +'code', name: 'Copy code', module: 'visitor', icon: 'icon-code-1', type: 'up', component: '' },
  //{ path: process.env.REACT_APP_ROUTE_PREFIX +'goal', name: 'Goals', module: 'goal', icon: 'icon-goal', type: 'up', component: '' },
  //{ path: process.env.REACT_APP_ROUTE_PREFIX +'analytic', module: 'analytic', name: 'Analytics', icon: 'icon-analytic', type: 'up', component: '' },
  // { path: process.env.REACT_APP_ROUTE_PREFIX +'integration', module: 'integration', name: 'Integrations', icon: 'icon-integration', type: 'down', component: '' },
  // { path: process.env.REACT_APP_ROUTE_PREFIX +'post', module: 'Post', name: 'Post', icon: 'icon-data', type: 'down', component: Post },
  // { path: process.env.REACT_APP_ROUTE_PREFIX +'review', module: 'Review', name: 'Review', icon: 'icon-data', type: 'down', component: Review },
];

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.js